import {Outlet, useLocation} from "react-router-dom";
import {SidebarInset, SidebarProvider} from "@components/shadcn-ui/sidebar";
import {SiteHeader} from "@components/Layout/SiteHeader";
import {SideNav} from "@components/Layout/SideNav";
import {Card, CardContent, CardHeader, CardTitle} from "@components/shadcn-ui/card";
import {Avatar, AvatarFallback} from "@components/shadcn-ui/avatar";
import {useAuth} from "../../context/AuthContext";
import {useEffect, useState} from "react";

export const SettingsPage = () => {
    const {userDetails} = useAuth();
    const { pathname } = useLocation();
    const [tokenInfo, setTokenInfo] = useState<{accessTokenAge: string, refreshTokenAge: string}>({accessTokenAge: 'N/A', refreshTokenAge: 'N/A'});

    useEffect(() => {
        const getTokenInfo = () => {
            const accessToken = localStorage.getItem('accessToken');
            const refreshToken = localStorage.getItem('refreshToken');
            
            const decodeToken = (token: string) => {
                try {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    return payload.iat ? new Date(payload.iat * 1000) : null;
                } catch {
                    return null;
                }
            };
            
            const getTimeAgo = (date: Date) => {
                const now = new Date();
                const diffMs = now.getTime() - date.getTime();
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                return diffHours > 0 ? `${diffHours}h ${diffMins}m ago` : `${diffMins}m ago`;
            };
            
            const accessTokenDate = accessToken ? decodeToken(accessToken) : null;
            const refreshTokenTimestamp = localStorage.getItem('refreshTokenTimestamp');
            const refreshTokenDate = refreshTokenTimestamp ? new Date(parseInt(refreshTokenTimestamp)) : null;
            
            setTokenInfo({
                accessTokenAge: accessTokenDate ? getTimeAgo(accessTokenDate) : 'N/A',
                refreshTokenAge: refreshTokenDate ? getTimeAgo(refreshTokenDate) : 'N/A'
            });
        };
        
        getTokenInfo();
        const interval = setInterval(getTokenInfo, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <SidebarProvider>
            <SidebarInset>
                <SiteHeader />
                <div className="md:flex flex-1 gap-4 pt-0 bg-gray-200 bg-opacity-50">
                    <div className="flex-1 p-6 space-y-6">
                        <Card className="max-w-2xl">
                            <CardHeader>
                                <CardTitle>User Profile</CardTitle>
                            </CardHeader>
                            <CardContent className="space-y-4">
                                <div className="flex items-center space-x-4">
                                    <Avatar className="h-16 w-16">
                                        <AvatarFallback className="text-lg">
                                            {userDetails?.userName?.charAt(0)?.toUpperCase() || 'U'}
                                        </AvatarFallback>
                                    </Avatar>
                                    <div>
                                        <h3 className="text-lg font-semibold">{userDetails?.userName || 'N/A'}</h3>
                                        <p className="text-gray-600">{userDetails?.email || 'N/A'}</p>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                                    <div>
                                        <label className="text-sm font-medium text-gray-700">Username</label>
                                        <p className="mt-1 text-sm text-gray-900">{userDetails?.userName || 'N/A'}</p>
                                    </div>
                                    <div>
                                        <label className="text-sm font-medium text-gray-700">Email</label>
                                        <p className="mt-1 text-sm text-gray-900">{userDetails?.email || 'N/A'}</p>
                                    </div>
                                    <div>
                                        <label className="text-sm font-medium text-gray-700">Role</label>
                                        <p className="mt-1 text-sm text-gray-900">{userDetails?.role || 'N/A'}</p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                        <Card className="max-w-2xl">
                            <CardHeader>
                                <CardTitle>Session Information</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-sm font-medium text-gray-700">Access Token Age</label>
                                        <p className="mt-1 text-sm text-gray-900">{tokenInfo.accessTokenAge}</p>
                                    </div>
                                    <div>
                                        <label className="text-sm font-medium text-gray-700">Refresh Token Age</label>
                                        <p className="mt-1 text-sm text-gray-900">{tokenInfo.refreshTokenAge}</p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
};
